/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.metadata.contentWarnings";

export { $nsid };

/** Content warnings for a stream. */
type Main = { $type?: "place.stream.metadata.contentWarnings";"warnings"?:("place.stream.metadata.contentWarnings#death" | "place.stream.metadata.contentWarnings#drugUse" | "place.stream.metadata.contentWarnings#fantasyViolence" | "place.stream.metadata.contentWarnings#flashingLights" | "place.stream.metadata.contentWarnings#language" | "place.stream.metadata.contentWarnings#nudity" | "place.stream.metadata.contentWarnings#PII" | "place.stream.metadata.contentWarnings#sexuality" | "place.stream.metadata.contentWarnings#suffering" | "place.stream.metadata.contentWarnings#violence" | l.UnknownString)[] };

export type { Main };

/** Content warnings for a stream. */
const main = /*#__PURE__*/ l.typedObject<Main>($nsid, "main", /*#__PURE__*/ l.object({"warnings":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.string<{"knownValues":["place.stream.metadata.contentWarnings#death","place.stream.metadata.contentWarnings#drugUse","place.stream.metadata.contentWarnings#fantasyViolence","place.stream.metadata.contentWarnings#flashingLights","place.stream.metadata.contentWarnings#language","place.stream.metadata.contentWarnings#nudity","place.stream.metadata.contentWarnings#PII","place.stream.metadata.contentWarnings#sexuality","place.stream.metadata.contentWarnings#suffering","place.stream.metadata.contentWarnings#violence"]}>(), ))}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);

/** The content could be perceived as offensive due to the discussion or display of death. */
type Death = "place.stream.metadata.contentWarnings#death";

export type { Death };

/** The content could be perceived as offensive due to the discussion or display of death. */
const death = /*#__PURE__*/ l.token($nsid, "death");

export { death };

/** The content contains a portrayal of the use or abuse of mind altering substances. */
type DrugUse = "place.stream.metadata.contentWarnings#drugUse";

export type { DrugUse };

/** The content contains a portrayal of the use or abuse of mind altering substances. */
const drugUse = /*#__PURE__*/ l.token($nsid, "drugUse");

export { drugUse };

/** The content contains violent actions of a fantasy nature, involving human or non-human characters in situations easily distinguishable from real life. */
type FantasyViolence = "place.stream.metadata.contentWarnings#fantasyViolence";

export type { FantasyViolence };

/** The content contains violent actions of a fantasy nature, involving human or non-human characters in situations easily distinguishable from real life. */
const fantasyViolence = /*#__PURE__*/ l.token($nsid, "fantasyViolence");

export { fantasyViolence };

/** The content contains flashing lights that could be harmful to viewers with seizure disorders such as photosensitive epilepsy. */
type FlashingLights = "place.stream.metadata.contentWarnings#flashingLights";

export type { FlashingLights };

/** The content contains flashing lights that could be harmful to viewers with seizure disorders such as photosensitive epilepsy. */
const flashingLights = /*#__PURE__*/ l.token($nsid, "flashingLights");

export { flashingLights };

/** The content could be perceived as offensive due to the language used. */
type Language = "place.stream.metadata.contentWarnings#language";

export type { Language };

/** The content could be perceived as offensive due to the language used. */
const language = /*#__PURE__*/ l.token($nsid, "language");

export { language };

/** The content could be perceived as offensive due to nudity. */
type Nudity = "place.stream.metadata.contentWarnings#nudity";

export type { Nudity };

/** The content could be perceived as offensive due to nudity. */
const nudity = /*#__PURE__*/ l.token($nsid, "nudity");

export { nudity };

/** The content contains information that can be used to identify a particular individual, such as a name, phone number, email address, physical address, or IP address. */
type Pii = "place.stream.metadata.contentWarnings#PII";

export type { Pii };

/** The content contains information that can be used to identify a particular individual, such as a name, phone number, email address, physical address, or IP address. */
const pii = /*#__PURE__*/ l.token($nsid, "PII");

export { pii as PII };

/** The content could be perceived as offensive due to the discussion or display of sexuality. */
type Sexuality = "place.stream.metadata.contentWarnings#sexuality";

export type { Sexuality };

/** The content could be perceived as offensive due to the discussion or display of sexuality. */
const sexuality = /*#__PURE__*/ l.token($nsid, "sexuality");

export { sexuality };

/** The content could be perceived as distressing due to the discussion or display of suffering or triggering topics, including suicide, eating disorders or self harm. */
type Suffering = "place.stream.metadata.contentWarnings#suffering";

export type { Suffering };

/** The content could be perceived as distressing due to the discussion or display of suffering or triggering topics, including suicide, eating disorders or self harm. */
const suffering = /*#__PURE__*/ l.token($nsid, "suffering");

export { suffering };

/** The content could be perceived as offensive due to the discussion or display of violence. */
type Violence = "place.stream.metadata.contentWarnings#violence";

export type { Violence };

/** The content could be perceived as offensive due to the discussion or display of violence. */
const violence = /*#__PURE__*/ l.token($nsid, "violence");

export { violence };
